import { createSatApi } from '../../../../lib-sat/api/api';
import { API_ERROR_UNEXPECTED_JOB_STATUS } from '../../../../lib-sat/api/consts';
import { globalLogger } from '../../../helper/global-logger.js';
import { conversionOptions } from '../../../../lib-sat/conversion-options/conversion-options';
import * as crop from './modules/crop';
import * as edit from './modules/edit';
import * as rotate from './modules/rotate';
import * as watermark from './modules/watermark';
import * as helper from './modules/helper';
import { getValueFromCurrentUrl } from '../../../helper/query-fragment-params';
import { testIsUUID4 } from '../../../../lib/test-and-assert/test-base';

import '../../../../vendor/pixie/scripts.min';
import { registerPlaceholderToggle } from '../../../../lib-sat/misc/misc';

var imgEditor = {
    crop: crop,
    rotate: rotate,
    watermark: watermark,
    edit: edit,
};

function initEditor(job, operation) {
    try {
        window.originalJob = job;

        helper.setOutputFilename(job);

        registerPlaceholderToggle();
        conversionOptions.setupTargetDropDown();
        conversionOptions.updateOptionsForDropDown();

        $('[id="submitBtn"]').prop('disabled', false);
        $('[id="submitBtnBottom"]').prop('disabled', false);

        imgEditor[operation].init(job);
    } catch (e) {
        globalLogger.error('image editor - exception - initEditor', e);
    }
}

window.initImageEditor = function (operation, uploaderConfig) {
    if (global.MODULE_LOADED_PIXIE) {
        globalLogger.log('double import pixie');

        return;
    }

    global.MODULE_LOADED_PIXIE = true;

    window.allowLeave = false;
    window.operation = operation;

    if (typeof uploaderConfig === 'object') {
        window.uploaderConfig = uploaderConfig;
    }

    const jobId = getValueFromCurrentUrl('j');

    if (jobId === null || !testIsUUID4(jobId)) {
        helper.showLoadingErrorBox();

        globalLogger.error('image editor - init invalid job id', 'invalid job id: ' + jobId);

        return;
    }

    var api = createSatApi({});

    api.getJobInfo(jobId)
        .done(function (job) {
            globalLogger.addLogData('job_id', job.id);

            window.originalJob = job;

            if (job.status.code === 'completed') {
                initEditor(job, operation);

                return;
            }

            if (job.status.code === 'failed') {
                globalLogger.error('image editor - init systemjob fail');

                helper.showLoadingErrorBox(job.id);

                return;
            }

            api.waitForCompletedJob(job.id)
                .done(function (jobInfo) {
                    initEditor(jobInfo, operation);
                })
                .fail(function (error) {
                    if (error === API_ERROR_UNEXPECTED_JOB_STATUS) {
                        globalLogger.error('image editor - init systemjob fail');

                        helper.showLoadingErrorBox(job.id);

                        return;
                    }

                    globalLogger.error('image editor - init getjobinfo fail');

                    helper.showLoadingErrorBox();
                });
        })
        .fail(function () {});
};
